import { useState, useEffect } from 'react';
import { Card, Box, Typography, TableBody, Paper, TableContainer, Table, TableHead, TableRow, TableCell, IconButton  } from '@mui/material';
import SupplierSelectComponent from '../../supplier-select-component/SupplierSelectComponent';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import "../asn-supp-summary-component/asn-supplier-summary";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useOktaAuth } from '@okta/okta-react';
import { useNotificationAPI } from '../../as2-onboarding-component/hooks/useClient';
import './supplierInitiatives.css'

const AllInitiatives = (props) => {
    const { oktaAuth } = useOktaAuth();
    const notificationApi = useNotificationAPI(oktaAuth.getAccessToken());

    const [initiatives, setInitiative] = useState([]);
    const { handleKeyDown, usertype } = props;

    function createData(id, title, created, status) {
        return { id, title, created, status };
    }

    const [rows, setRows] = useState([]);
    const [onFilter, setOnFilter] = useState(rows);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const fetchNotifications = async () => {
        try {
            const response = await notificationApi.get('/notifications');
            const data = response.data;
            const notifications = []
            const initiativesList = []

            data.map(async (element) => {
                notifications.push(createData(element.notification.id, element.notification.title, element.notification.creation_date.substring(0, 10), element.notification.notification_read ? 'Read' : 'Pending'))
                initiativesList.push(element.notification.title)
            })

            setRows(notifications);
            setOnFilter(notifications);
            setInitiative(initiativesList);

        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    }

    useEffect(() => {
        fetchNotifications();
    }, []);

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const sortedRows = [...rows].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const supplierChangeHandler = (event) => {
        const number = event.value
        const filteredRows = rows.filter(row => row.title === number.toString())
        setOnFilter(filteredRows)
    }

    const handleDelete = (id) => {
        if (!id) return;
        const filteredRows = rows.filter((row) => row.id !== id);
        setOnFilter(filteredRows)
        setRows(filteredRows)
    }

    return (
        <Box p={10}>
            <Card className='cardcontainers' sx={{ width: "40%" }} >
                <Typography variant="h5" fontWeight="semibold" component="p" gutterBottom>
                    Initiative name
                    {/* <span style={{ color: "red" }}>*</span> */}
                </Typography>
                <SupplierSelectComponent
                    userType={usertype}
                    supplierList={initiatives}
                    supplierChangeHandler={supplierChangeHandler}
                    handleKeyDown={handleKeyDown}
                />
            </Card>
            <br />
            <Box sx={{ "textAlign": "left", "padding-top": "3rem", "padding-left": "1rem" }}>
                <Typography size="large" fontWeight="bold" component="p" gutterBottom>
                    Recent initiatives
                </Typography>
            </Box>
            <Box p={2} >
                <TableContainer className='table-container'>
                    <Table>
                        <TableHead className='table-row'>
                            <TableRow  >
                                <TableCell className='table-header-cell' onClick={() => handleSort('title')} align="center">
                                    <Typography variant="h6">
                                        Title <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                                <TableCell className='table-header-cell' onClick={() => handleSort('created')} align="center">
                                    <Typography variant="h6">
                                        Created <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                                <TableCell className='table-header-cell' onClick={() => handleSort('status')} align="center">
                                    <Typography variant="h6" pl={2}>
                                        Status <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                                <TableCell className='table-header-cell' onClick={() => handleSort('status')} align="center">
                                    <Typography variant="h6" pl={2}>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {onFilter.map((row, index) => (
                                <TableRow key={index} className='table-row'>
                                    <TableCell colSpan={4} className='table-body-cell'>
                                        <Box component={Paper} className='table-main-box' >
                                            <Box className="table-box">
                                                <Typography variant="body2" fontWeight="bold" color='#2e7d32'>{row.title}</Typography>
                                            </Box>
                                            <Box className="table-box">
                                                <Typography variant="body2">{row.created}</Typography>
                                            </Box>
                                            <Box className="table-box">
                                                <FiberManualRecordIcon fontSize="0.9rem" color={row.status === 'Pending' ? 'error' : 'success'} />
                                                <Typography variant="body2" color={row.status === 'Pending' ? 'error' : '#2e7d32'} fontWeight="bold">{row.status}</Typography>
                                            </Box>
                                            <Box className="table-icon-button">
                                                {row.status === 'Pending' ?
                                                    <IconButton >
                                                        <EditIcon fontSize='small' sx={{ color: 'grey' }} />
                                                    </IconButton>
                                                    :
                                                    <IconButton onClick={() => handleDelete(row.id)} >
                                                        <DeleteIcon fontSize='small' color='error' />
                                                    </IconButton>}
                                                <IconButton>
                                                    <GroupIcon fontSize='small' sx={{ color: '#2e7d32' }} />
                                                </IconButton>
                                                <IconButton sx={{color : row.status === 'Pending' ? '' : '#2e7d32'}}>
                                                    <CheckCircleOutlineIcon fontSize='small'  />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )
}

export default AllInitiatives
